import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "hero-wrap" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "hero-give" };
const _hoisted_5 = { class: "hero-amount" };
const _hoisted_6 = { class: "hero-get" };
const _hoisted_7 = { class: "hero-amount" };
const _hoisted_8 = { class: "intro" };
const _hoisted_9 = { class: "intro-body" };
const _hoisted_10 = { class: "card" };
const _hoisted_11 = { class: "invite-btn" };
const _hoisted_12 = { class: "footnotes" };
const _hoisted_13 = {
    key: 0,
    class: "footnote"
};
const _hoisted_14 = {
    key: 1,
    class: "footnote footnote--unavailable"
};
const _hoisted_15 = { class: "stats-row" };
const _hoisted_16 = { class: "stat-tile stat-tile--light" };
const _hoisted_17 = { class: "stat-bottom" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "stat-value" };
const _hoisted_20 = { class: "stat-tile stat-tile--purple" };
const _hoisted_21 = { class: "stat-bottom" };
const _hoisted_22 = { class: "earned-icon-wrap" };
const _hoisted_23 = ["src"];
const _hoisted_24 = { class: "stat-value" };
const _hoisted_25 = {
    key: 0,
    class: "referral-list"
};
const _hoisted_26 = { class: "referral-details" };
const _hoisted_27 = { class: "referral-name" };
const _hoisted_28 = { class: "referral-joined" };
const _hoisted_29 = { class: "reward-chip" };
const _hoisted_30 = { class: "info-content" };
const _hoisted_31 = { key: 0 };
import { ref, computed, onMounted } from 'vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import ReferMGMPage from './ReferMGMPage.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import { useAuth } from '@/composables/useAuth';
import { useReferrals } from '@/composables/useReferrals';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MyMGMPage',
    setup(__props) {
        useAuth();
        const state = useAppState();
        const { referrals, totalEarned, referrerCredit, refereeCredit, maxReferralsPerMember, available, loaded, getReferrals } = useReferrals();
        // Only list referrals that actually earned the member a reward.
        const creditedReferrals = computed(() => referrals.value.filter(r => Number(r.amount) > 0));
        const rewardCap = computed(() => maxReferralsPerMember.value != null ? formatMoney(maxReferralsPerMember.value * referrerCredit.value) : null);
        const referOpen = ref(false);
        const infoOpen = ref(false);
        // short + stripIfInteger: whole amounts render as "£5" on the hero
        function formatHeroMoney(amount) {
            return state.formatter.format(Number(amount) || 0, true, false);
        }
        // Round all amounts on this page — no decimals (e.g. "£5", "£25").
        function formatMoney(amount) {
            return state.formatter.format(Number(amount) || 0, true, false);
        }
        function formatDate(date) {
            if (!date)
                return '';
            const d = new Date(date);
            if (isNaN(d.getTime()))
                return '';
            return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
        }
        // Open the referral sheet (code + share).
        function invite() {
            referOpen.value = true;
        }
        onMounted(() => {
            getReferrals();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Invite your colleagues",
                    info: true,
                    onInfo: _cache[0] || (_cache[0] = ($event) => (infoOpen.value = true))
                }),
                _createElementVNode("div", _hoisted_1, [
                    (_unref(loaded))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("img", {
                                    src: require('@/assets/refer-hero.png'),
                                    alt: "",
                                    class: "hero"
                                }, null, 8, _hoisted_3),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(formatHeroMoney(_unref(refereeCredit))), 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "hero-label" }, "for them", -1))
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(formatHeroMoney(_unref(referrerCredit))), 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hero-label" }, "for you", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "intro-title" }, [
                                    _createTextVNode("Share Money Guided."),
                                    _createElementVNode("br"),
                                    _createTextVNode("Get rewarded.")
                                ], -1)),
                                _createElementVNode("p", _hoisted_9, "Invite colleagues to Money Guided and you'll both receive " + _toDisplayString(formatMoney(_unref(refereeCredit))) + " in Saved to Spend to spend on vouchers from hundreds of popular brands.", 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(MGButton, {
                                        text: "Invite a colleague",
                                        arrow: true,
                                        fullWidth: true,
                                        onClick: invite,
                                        noCaps: true,
                                        disabled: !_unref(available)
                                    }, null, 8, ["disabled"])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    (_unref(available))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (rewardCap.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Earn up to " + _toDisplayString(rewardCap.value) + " in referral rewards.", 1))
                                                : _createCommentVNode("", true),
                                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "footnote" }, "Offer and rewards subject to availability.", -1))
                                        ], 64))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_14, "This offer has ended or a reward limit has been reached."))
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "stat-label" }, "Colleagues invited", -1)),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/icons/face-smile-purple.svg'),
                                                alt: "",
                                                class: "stat-icon"
                                            }, null, 8, _hoisted_18),
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(referrals).length), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "stat-label" }, "Rewards earned", -1)),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("img", {
                                                    src: require('@/assets/icons/coins-swap.png'),
                                                    alt: "",
                                                    class: "earned-icon"
                                                }, null, 8, _hoisted_23)
                                            ]),
                                            _createElementVNode("span", _hoisted_24, _toDisplayString(formatMoney(_unref(totalEarned))), 1)
                                        ])
                                    ])
                                ]),
                                (creditedReferrals.value.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creditedReferrals.value, (r, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: i,
                                                class: "referral-row"
                                            }, [
                                                _createElementVNode("div", _hoisted_26, [
                                                    _createElementVNode("p", _hoisted_27, _toDisplayString(r.name), 1),
                                                    _createElementVNode("p", _hoisted_28, "Referral reward received " + _toDisplayString(formatDate(r.joined)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_29, "+" + _toDisplayString(formatMoney(r.amount)), 1)
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"skel skel-hero\" data-v-ea1db58e></div><div class=\"intro\" data-v-ea1db58e><div class=\"skel skel-title\" data-v-ea1db58e></div><div class=\"skel skel-body\" data-v-ea1db58e></div><div class=\"skel skel-body skel-body--short\" data-v-ea1db58e></div></div><div class=\"skel skel-card\" data-v-ea1db58e></div>", 3))
                        ], 64))
                ]),
                _createVNode(ReferMGMPage, {
                    modelValue: referOpen.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((referOpen).value = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: infoOpen.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((infoOpen).value = $event)),
                    title: "How it works",
                    closeButton: true,
                    height: "65vh"
                }, {
                    footer: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Done",
                            fullWidth: true,
                            noCaps: true,
                            onClick: _cache[2] || (_cache[2] = ($event) => (infoOpen.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Money Guided is better with company. When you invite a colleague to join, you both win.", -1)),
                            _createElementVNode("p", null, "Share your referral code with a colleague. When they sign up and enter it, we'll add " + _toDisplayString(formatMoney(_unref(referrerCredit))) + " to your Saved to Spend — and " + _toDisplayString(formatMoney(_unref(refereeCredit))) + " to theirs too.", 1),
                            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Your Saved to Spend balance can be put towards vouchers for groceries, shopping, travel, dining and more.", -1)),
                            _createElementVNode("p", null, [
                                _cache[11] || (_cache[11] = _createTextVNode("There's no limit to how many colleagues you can invite")),
                                (rewardCap.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, ", and you can earn up to " + _toDisplayString(rewardCap.value) + " in referral rewards", 1))
                                    : _createCommentVNode("", true),
                                _cache[12] || (_cache[12] = _createTextVNode("."))
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
